/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")


  
    
export interface API20946Item {
  
  /** 模块id */
  resourceId?: string;
  
  /** 模块名称 */
  resourceName?: string;
  
  /** 标识 */
  nameEn?: string;
  
  /** 绝对路径 */
  url?: string;
  
  /** 模块id */
  moduleId?: string;
  
  /** 模块英文名 */
  moduleNameEn?: string;
  
  /** 模块名称 */
  moduleName?: string;
  
  /** 云分类id */
  cloudCategoryId?: string;
  
  /** 项目id */
  projectId?: string;
  
  /** 是否有权限 */
  isHasResource?: boolean;
  
};
    
  



  export type API20946Req = {};



export interface API20946Res {
  /** T  */
  list?: API20946Item[];
  
};


// 20946 显示用户的常用功能

export interface IUseGetAPI20946Return {
  /** 显示用户的常用功能: 接口请求状态 */
  isAPI20946Loading: boolean;
  /** 显示用户的常用功能: 接口请求返回数据 */
  dataAPI20946: API20946Res;
  /**  显示用户的常用功能: 接口数据请求方法 */
  fetchAPI20946Data:  ( config?: YWRequestConfig) => Promise<API20946Res>;
  /** 显示用户的常用功能: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI20946 = ():IUseGetAPI20946Return => {
  let isMount = true;
  const [isAPI20946Loading, setIsAPI20946Loading] = useState(false);
  const [dataAPI20946, setDataAPI20946] = useState<API20946Res>({} as API20946Res);
  const requestUrl = `${basePath}/ywwl-admin/desktop/home/common/function/list`;

  const fetchAPI20946Data = async ( config?: YWRequestConfig): Promise<API20946Res> => {
  
    if ( isMount ) {
      setIsAPI20946Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API20946Res>(`${basePath}/ywwl-admin/desktop/home/common/function/list`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI20946(res || {} as API20946Res);
        setIsAPI20946Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI20946Loading(false);
      }
      return false as unknown as API20946Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI20946Loading,
    dataAPI20946,
    fetchAPI20946Data,
    requestUrl,
  }
}

